import { render, staticRenderFns } from "./communityCode.vue?vue&type=template&id=af4a7ab4&scoped=true&"
import script from "./communityCode.vue?vue&type=script&lang=js&"
export * from "./communityCode.vue?vue&type=script&lang=js&"
import style0 from "./communityCode.vue?vue&type=style&index=0&id=af4a7ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a7ab4",
  null
  
)

export default component.exports